import React from 'react'

import Link from 'shared/components/common/link'

import { useDisplayPageContext } from '../../DisplayPageContext'

const VomBreadcrumbs = ({ name }: { name: string }) => {
  const { breadcrumbBasePath, breadcrumbBaseName } = useDisplayPageContext()

  const crumbs = []

  crumbs.push({
    name,
    path: '' // the menu item breadcrumb isn't clickable
  })

  const numCrumbs = crumbs.length
  const crumbNodes = crumbs.map((crumb, i) => {
    return (
      <React.Fragment key={i}>
        <li className='crumb slash'>/</li>
        <li className='crumb'>
          {i < numCrumbs - 1 ? (
            <Link href={crumb.path} sameTab>
              {crumb.name}
            </Link>
          ) : (
            crumb.name
          )}
        </li>
      </React.Fragment>
    )
  })

  // prepend the crumbs with the "Home" text.
  crumbNodes.unshift(
    <li className='crumb' key={-1}>
      <Link href={breadcrumbBasePath} sameTab>
        {breadcrumbBaseName}
      </Link>
    </li>
  )

  return (
    <div className='breadcrumbs'>
      <ul>{crumbNodes}</ul>
    </div>
  )
}

export default VomBreadcrumbs
